import { ResultsTableQuestion } from '~teacher/components/ResultsGrid/ResultsTable';
import { QuestionScore, Student } from '~teacher/models/activities';
import { QuizQuestion } from '~teacher/models/quizzes';

import { effectiveQuestionWeight } from '../scoreCalculation';
import { calculateQuestionQuizTotal } from '../scoreCalculation/calculateStudentQuestionScore/calculateQuestionQuizTotal';
import { NormalizedResponse } from './normalizeResponses';

const countParticipatingStudents = (
  students: Student[] = [],
  questionScore: QuestionScore,
  responses: NormalizedResponse
) =>
  students
    .filter(
      (student) =>
        !!questionScore?.studentScores[student.id] ||
        !!responses.byStudentId[student.id]
    )
    .reduce((length) => (length += 1), 0);

export function mapQuestionsToResultsTableQuestions({
  order,
  questions,
  questionScores,
  students,
  responses,
}: {
  order: Array<number>;
  questions: Record<string, QuizQuestion>;
  questionScores: Record<string, QuestionScore>;
  students: Student[];
  responses: NormalizedResponse;
}): ResultsTableQuestion[] {
  return order
    .map((questionId) => {
      const question = questions[questionId];
      const questionScore = questionScores ? questionScores[questionId] : null;
      return [question, questionScore] as const;
    })
    .map(([question, questionScore]) => ({
      path: '#',
      order: question.order,
      type: question.type,
      questionId: +question.questionId,
      hasCorrectAnswer: question.hasCorrectAnswer,
      gradingWeight: effectiveQuestionWeight({ question, questionScore }),
      totalParticipants: countParticipatingStudents(
        students,
        questionScore,
        responses
      ),
      totalGrades: calculateQuestionQuizTotal(
        students,
        question,
        responses,
        questionScores
      ),
    }));
}
